import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { MachineTeaserCard } from '@/components/home/MachineTeaserCard';
import { SectionHeading } from '@/components/home/helpers';
import { ArrowRight, Factory } from 'lucide-react';

export const MachineTeaserSection = ({ machines, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section
      className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800"
      data-testid="machine-teaser-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
        <SectionHeading
          label={t('home.machines.label')}
          title={t('home.machines.title')}
          subtitle={t('home.machines.subtitle')}
          accentColor="#2563EB"
          testId="machines-heading"
          cta={
            <Button
              variant="outline"
              onClick={() => navigate('/listings?vertical=machines')}
              data-testid="see-all-machines-btn"
              className="rounded-none border-slate-900 dark:border-slate-100 text-slate-900 dark:text-slate-100 hover:bg-slate-900 dark:hover:bg-slate-100 hover:text-white dark:hover:text-slate-900 gap-2"
            >
              {t('home.machines.seeAll')}
              <ArrowRight className="h-4 w-4" />
            </Button>
          }
        />
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} className="h-80 rounded-none" />
            ))}
          </div>
        ) : machines.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {machines.map((m) => (
              <MachineTeaserCard key={m.listing_id} listing={m} />
            ))}
          </div>
        ) : (
          <div className="border border-dashed border-slate-300 dark:border-slate-700 p-10 text-center">
            <Factory className="h-10 w-10 mx-auto text-slate-300 dark:text-slate-600 mb-3" />
            <p className="text-sm text-slate-600 dark:text-slate-400">
              {t('home.machines.emptyDesc')}{' '}
              <button
                className="text-blue-600 dark:text-blue-400 font-semibold underline underline-offset-2"
                onClick={() => navigate('/listing/new?vertical=machines')}
                data-testid="empty-machines-create-btn"
              >
                {t('home.machines.emptyCreate')}
              </button>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
